<template>
    <div
        class="col-xl-3 col-sm-6"
      >
        <div class="card text-center" :style="(active) ? 'background-color: #e91e63 !important;' : null">
          <div class="card-body">
            
            <div class="clearfix"></div>
            <div class="mb-4">
              <img
                :src="image"
                alt
                class="avatar-lg rounded-circle img-thumbnail"
                :style="(name == 'No Achievement') ? 'background-color: white !important;' : null"
              />
            </div>
            <h5 class="font-size-16 mb-1">
              <a href="#" class="text-dark">{{ name }}</a>
            </h5>
            <p class="text-muted mb-2">{{ tokens }} Tokens</p>
          </div>
        </div>
      </div>
</template>

<script>
export default {
    name: "Achievement",
    props: [
        "active",
        "image",
        "name",
        "tokens"
    ]
}
</script>